import constate from "constate";
function useConfigInternal(args) {
    return args;
}
export const [VizFrameworkConfigProvider, useConfigStrict] = constate(useConfigInternal);
/**
 * Hook to access the config object from the VizFrameworkProvider.
 */ export function useVizFrameworkConfig() {
    try {
        return useConfigStrict();
    } catch (e) {
        return undefined;
    }
}

//# sourceMappingURL=config.js.map